export default {
  carrito: {
    modelo: "",
    color: null,
    colorCode: '',
    reprocesos: [],
    lineas: {

    },
    productos: [
    ],
    cantidad: 0,
    total: 0.0,
    nreprocesos: [],
  },
  loading: 0,
  sobrecosteCantidadExacta: 0,
  paramsCantidadExacta: null,
  calcularPlanchado: [],
  comercialCart: [],
  clientCart: [],
  completeCart: '',
  lastCart: [],
  
  shippingAddress: [],
  infoTecnicaActualZone: {} // Información de la técnica para la zona actual
  
};
